import './OpeningHoursComponent.scss';
export default function OpeningHoursComponent() {
    return (
        <section id='timing' className='tw-px-8 md:tw-px-16 opening-hours tw-px-16 tw-pt-[45px] md:tw-pt-[90px]'>
            <h3 className='tw-flex tw-justify-center tw-uppercase section-header'>
                Coffee O’Clock
            </h3>
            <div className="tw-my-2 md:tw-my-16 tw-grid tw-grid-cols-12 tw-gap-4">
                <div className='tw-col-span-12 md:tw-col-span-2'></div>
                <div className="tw-col-span-12 md:tw-col-span-4 tw-text-center opening-announcement">
                    Catch Us While We’re Open!
                </div>
                <div className="tw-col-span-12 md:tw-col-span-4 md:tw-text-center">
                    <div className='day-group grid grid-cols-2 md:grid-cols-3 content-center gap-4'>
                        <div className='day'>Monday</div>
                        <div className='time tw-pl-8'>07:00 - 15:00</div>
                    </div>
                    <div className='day-group grid grid-cols-2 md:grid-cols-3 content-center gap-4'>
                        <div className='day'>Tuesday</div>
                        <div className='time tw-pl-8'>07:00 - 15:00</div>
                    </div>
                    <div className='day-group grid grid-cols-2 md:grid-cols-3 content-center gap-4'>
                        <div className='day'>Wednesday</div>
                        <div className='time tw-pl-8'>07:00 - 15:00</div>
                    </div>
                    <div className='day-group grid grid-cols-2 md:grid-cols-3 content-center gap-4'>
                        <div className='day'>Thursday</div>
                        <div className='time tw-pl-8'>07:00 - 15:00</div>
                    </div>
                    <div className='day-group grid grid-cols-2 md:grid-cols-3 content-center gap-4'>
                        <div className='day'>Friday</div>
                        <div className='time tw-pl-8'>07:00 - 15:00</div>
                    </div>
                    <div className='day-group grid grid-cols-2 md:grid-cols-3 content-center gap-4'>
                        <div className='day'>Saturday</div>
                        <div className='time tw-pl-8'>Closed</div>
                    </div>
                    <div className='day-group grid grid-cols-2 md:grid-cols-3 content-center gap-4'>
                        <div className='day'>Sunday</div>
                        <div className='time tw-pl-8'>Closed</div>
                    </div>
                </div>
                <div className='tw-col-span-12 md:tw-col-span-2'></div>
            </div>
        </section>
    );
}